import React, { useCallback } from 'react';
import { confirm } from 'components/atoms/modal';
import { useTranslate } from 'hooks/use-translation';

interface Props {
  onAutoAllocateEnable: () => void;
  onAutoAllocateDisable: () => void;
}

interface Result {
  confirmEnableAutoAllocation: () => void;
  confirmDisableAutoAllocation: () => void;
  changeAutoAllocateState: (isAutoAllocationOn: boolean) => void;
}

export const useAutoAllocateConfirmation = ({
  onAutoAllocateEnable,
  onAutoAllocateDisable,
}: Props): Result => {
  const translate = useTranslate();

  const confirmEnableAutoAllocation = useCallback(() => {
    confirm({
      title: translate(
        'resource_management.auto_allocation.enable.confirmation.title',
      ),
      content: translate(
        'resource_management.auto_allocation.enable.confirmation.message',
        { br: () => <br /> },
      ),
      onOk: () => {
        onAutoAllocateEnable();
      },
    });
  }, [onAutoAllocateEnable, translate]);
  const confirmDisableAutoAllocation = useCallback(() => {
    confirm({
      title: translate(
        'resource_management.auto_allocation.disable.confirmation.title',
      ),
      content: translate(
        'resource_management.auto_allocation.disable.confirmation.message',
      ),
      onOk: () => {
        onAutoAllocateDisable();
      },
    });
  }, [onAutoAllocateDisable, translate]);
  const changeAutoAllocateState = useCallback(
    (isAutoAllocateOn: boolean) => {
      if (isAutoAllocateOn) {
        confirmDisableAutoAllocation();
      } else {
        confirmEnableAutoAllocation();
      }
    },
    [confirmDisableAutoAllocation, confirmEnableAutoAllocation],
  );

  return {
    confirmEnableAutoAllocation,
    confirmDisableAutoAllocation,
    changeAutoAllocateState,
  };
};
